export const APP_NOTIFY_EVENT = 'app-notify';

export const emitNotification = ({ type = 'info', message, duration = 10000 } = {}) => {
  if (!message || typeof window === 'undefined') {
    return;
  }

  window.dispatchEvent(
    new CustomEvent(APP_NOTIFY_EVENT, {
      detail: {
        id: `${Date.now()}-${Math.random().toString(16).slice(2)}`,
        type,
        message,
        duration,
      },
    })
  );
};

export const emitErrorNotification = (message, duration) =>
  emitNotification({ type: 'error', message, duration });

export const emitSuccessNotification = (message, duration) =>
  emitNotification({ type: 'success', message, duration });
